<template>
  <div style="z-index: 9999999">
    <el-button size="mini" @click="openDialog = true" class="examine">{{ btn }}</el-button>
    <input type="file" ref="files" @change="upload" hidden/>
    <!-- 添加附件对话框 -->
    <el-dialog
        title=""
        :modal="modal"
        :visible.sync="openDialog"
        width="30%"
        class="large"
        :before-close="closeAcces"
        ref="formOpen"
    >
      <el-form v-show="states">
        <el-form-item label="">
          <el-button :disabled="progressState" class="btn" size="small" @click="openFile">点击上传</el-button>
          <el-progress v-show="progressState" :format="formatText" :percentage="progress"></el-progress>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" style="width: 100%" class="button-box">
        <el-table-column prop="name" label="附件名称"></el-table-column>
        <el-table-column prop="createDatetime" label="上传时间">
          <template slot-scope="scope">
            {{ scope.row.createDatetime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="下载">
          <template slot-scope="scope">
            <a :href="`${getaway.user}bt/file/${scope.row.md5}/download`">下载</a>
          </template>
        </el-table-column>
        <el-table-column v-if="states" prop="address" label="移出">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" @click="annexRemove(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAcces">取 消</el-button>
        <el-button @click="addAcces">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BigUpload from "@/js/upload";

export default {
  name: 'accessory',
  props: {
    states: {
      type: Boolean,
      default: false,
    },
    statesBrief: {
      type: Boolean,
      default: false,
    },
    md5s: {
      type: String,
      default: '',
    },
    btn: {
      type: String,
      default: '查看',
    },
    field: {
      type: String,
      default: '',
    },
    row: {
      type: Object,
    },
  },
  data() {
    return {
      modal: false,
      tableData: [],
      md5: '',
      openDialog: false,
      uploadFile: null,
      progressState: false,
      progress: 0
    }
  },
  watch: {
    openDialog(val) {
      if (val) {
        this.loadMd5()
      }
    },
  },
  mounted() {
    this.initialize();

  },
  methods: {
    initialize() {
      this.$nextTick(() => {
        this.uploadFile = new BigUpload({
          url: `${this.getaway.user}bt/files/bigupload`,
          file: this.$refs.files,
          size: 2097152,
          callback: (state) => {
            if (state) {
              this.progressState = false;
              this.tableData.push({
                md5: state.md5,
                createDatetime: state.createDatetime,
                name: state.name,
              })
            }
          },
          drowSpeed: (p) => {
            this.progress = p
          }
        });
      });

    },
    formatText(p) {
      if (p === 0) {
        return '正在读取……';
      } else {
        return p + "%";
      }
    },
    openFile() {
      //触发单击事件
      this.$refs.files.click();
    },
    upload() {
      let state = this.uploadFile.startUpload();
      if (state) {
        this.progressState = true;
      }
    },
    loadMd5() {
      this.md5 = this.md5s
      if (!this.md5) {
        if (this.row && this.field) {
          this.md5 = this.row[this.field]
        }
      }
      if (!this.md5) return
      this.loading = true
      this.axios
          .get(
              `${this.getaway.user}bt/file/batchSelectMd5?md5List=${this.md5}`
          )
          .then((res) => {
            this.loading = false
            if (res.code == 0 && res.data) {
              res.data.forEach((f) => {
                this.tableData.push({
                  md5: f.md5,
                  createDatetime: f.createDatetime,
                  name: f.name,
                })
              })
            }
          })
    },
    annexRemove(row) {
      this.tableData.remove(row)
    },
    // 上传之后返回的数据
    anneSuccess(response) {
      const md5 = response.data.md5
      const createDatetime = response.data.createDatetime
      const name = response.data.name
      if (response.code === '0') {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.tableData.push({
          md5: md5,
          createDatetime: createDatetime,
          name: name,
        })
      }
    },

    addAcces() {
      if (this.tableData && this.tableData.length > 0) {
        let md5 = []
        this.tableData.forEach((t) => {
          md5.push(t.md5)
        })
        if (this.row && this.field) {
          this.row[this.field] = md5.join(',')
        }
        this.$emit('getfiles', this.tableData)
        this.$emit('callback', md5)
      } else {
        if (this.row && this.field) {
          this.row[this.field] = ''
        }
        this.$emit('getfiles', this.tableData)
        this.$emit('callback', '')
      }
      this.closeAcces()
    },

    closeAcces() {
      this.openDialog = false
      this.tableData = []
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-upload.upload-demo {
  text-align: left;
}
.el-dialog .el-button--primary {
  border: 1px solid #d8e1f2;
}
</style>
